import { render, staticRenderFns } from "./GalleryPage.vue?vue&type=template&id=1046aea0&scoped=true&"
import script from "./GalleryPage.vue?vue&type=script&lang=js&"
export * from "./GalleryPage.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPage.vue?vue&type=style&index=0&id=1046aea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1046aea0",
  null
  
)

component.options.__file = "GalleryPage.vue"
export default component.exports